export default `
  subscription OnCreateCardAttachment($workflowId: String) {
    onCreateCardAttachment(workflowId: $workflowId) {
      id
      type
      url
      dateCreated
      name
      mimeType
      cardId
      workflowId
    }
  }
`
